<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="16">
          <a-col :xl="6" :lg="8" :md="8" :sm="24">
            <a-form-item label="进场类别">
              <a-select
                showSearch
                placeholder="请选择"
                default-value="tree"
                v-model="category"
              >
                <a-select-option value="tree">进场苗木</a-select-option>
                <a-select-option value="material">进场主材</a-select-option>
                <a-select-option value="asset">固定资产</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="5" :lg="8" :md="8" :sm="24">
            <a-form-item label="日期">
              <a-date-picker
                @change="onTimeChange"
                format="YYYY-MM-DD"
                v-model="clearDate"
                style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :xl="8" :lg="8" :md="8" :sm="24">
            <a-form-item label="项目名称">
              <a-select
                style="max-width: 200px;min-width: 100%"
                showSearch
                placeholder="请选择"
                :filterOption="filterOption"
                :options="projectList"
                v-model="queryParam.projectName">
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="5" :lg="8" :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="() => {this.queryPage()}" type="primary">查询</a-button>
              <a-button @click="() => {queryParam = {}, clearDate = undefined}" style="margin-left: 8px">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <s-table
      bordered
      ref="table"
      :columns="columns"
      :data="loadData"
      :rowKey="record => record.id"
      :pagination="pagination"
    >
      <span slot="action" slot-scope="text,record">
        <div>
          <span v-action="'purchase:purchaseInfo:confirm'" v-if="record.status === '0'||userInfo.username === 'admin'">
            <a @click="confirm(record)">信息确认</a>
            <a-divider type="vertical" />
          </span>
          <span>
            <a @click="show(record)">详情</a>
          </span>
        </div>
      </span>
    </s-table>
    <add-price-form ref="addPriceModal" @ok="initSon"></add-price-form>
  </a-card>
</template>

<script>
import AddPriceForm from './component/AddPriceForm'
import { TableMixin } from '@/mixins/TableMixin'
import { treeList, materialList, assetList } from '@/api/common/Purchase'
import { dropProjectList } from '@/api/project/ProjectInfo'
import { enterEvent } from '@/utils/util'
import { mapState } from 'vuex'
export default {
  name: 'PurchaseInfo',
  mixins: [TableMixin],
  components: {
    AddPriceForm
  },
  data () {
    return {
      description: '确认进场苗木、进场主材、固定资产的单价，以及选择供货商',
      projectList: [],
      clearDate: undefined,
      category: 'tree',
      dateFormat: 'YYYY/MM/DD',
      queryParam: {
        projectName: undefined,
        date: undefined
        // date: ''
      },
      loadData: parameter => {
        if (this.category === 'tree') {
          return treeList(
            Object.assign(parameter, this.queryParam)
          ).then(res => {
            return res.data
          })
        }
        if (this.category === 'material') {
          return materialList(
            Object.assign(parameter, this.queryParam)
          ).then(res => {
            return res.data
          })
        }
        if (this.category === 'asset') {
          return assetList(
            Object.assign(parameter, this.queryParam)
          ).then(res => {
            return res.data
          })
        }
      },
      // 表头
      columns: [
        {
          title: '序号',
          width: '62px',
          customRender: (text, record, index) => {
            return (
              <div>
                {index + 1}
              </div>
            )
          }
        },
        {
          title: '采购人',
          dataIndex: 'purchaser'
        },
        {
          title: '名称',
          dataIndex: 'name'
        },
        {
          title: '规格',
          dataIndex: 'format'
        },
        {
          title: '数量',
          dataIndex: 'number'
        },
        {
          title: '单位',
          dataIndex: 'unit'
        },
        {
          title: '供货商',
          dataIndex: 'supplier'
        },
        {
          title: '单价',
          dataIndex: 'unitPrice',
          customRender: (text) => {
            return (
              <div style="float:right">
                { text === null ? ' - ' : Number(text).toFixed(3)}
              </div>
            )
          }
        },
        {
          title: '总价',
          dataIndex: 'totalPrice',
          customRender: (text, record, index) => {
            return (
              <div style="float:right">
                { text === null ? ' - ' : Number(text).toFixed(2)}
              </div>
            )
          }
        },
        {
          title: '日期',
          dataIndex: 'date'
        },
        {
          title: '操作',
          width: '140px',
          scopedSlots: { customRender: 'action' }
        }
      ],
      pagination: {
        showQuickJumper: true,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '40', '50']
      }
    }
  },
  mounted () {
    this.init()
    enterEvent(this.queryPage)
  },
  computed: {
    ...mapState({
      username: (state) => state.user.username,
      welcome: (state) => state.user.welcome
    }),
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  methods: {
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    init () {
      dropProjectList().then(res => {
        this.projectList = res.data
      })
    },
    initSon () {
      this.init()
      this.queryPage()
    },
    confirm (record) {
      this.$refs.addPriceModal.init(record.id, this.category, 'edit')
    },
    show (record) {
      this.$refs.addPriceModal.init(record.id, this.category, 'show')
    },
    onTimeChange (date, dateString) {
      if (date !== null) {
        this.queryParam.date = date.format('YYYY-MM-DD')
      } else {
        this.queryParam.date = undefined
      }
    }
  }
}
</script>
